import { Component, OnInit, Input } from '@angular/core';
import { Langue } from 'app/models/langue';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'app/utils/notifications.service';
import { LangueService } from 'app/core/langue.service';

@Component({
  selector: 'app-ajoutlangue',
  templateUrl: './ajoutlangue.component.html',
  styleUrls: ['./ajoutlangue.component.css']
})
export class AjoutlangueComponent implements OnInit {

  @Input()
  langue:Langue;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private langueService:LangueService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  submitForm() {
    const valeur: any = this.form.value;
    console.log(valeur);
    this.langueService.create(valeur).subscribe(
      langue => {
        if (this.langue) {
          this.notification.addToast(
            "Langue a ete bien créee",
            "infos",
            "success"
          );
        } else {
          this.notification.addToast(
            "Langue a ete bien créee",
            "infos",
            "success"
          );
        }
      },
      error => {
        if (this.langue) {
          this.notification.addToast(
            "Erreur sur Modification",
            'Attention', 'error'
          );
        } else {
          this.notification.addToast(
            "Erreur sur Création",
            'Attention', 'error'
          );
        }
      }
    );

    this.activeModal.dismiss("cancelled by user");
    this.ngOnInit();
  }


  public initForm() {
    if (this.langue) {
      this.form = this.formBuilder.group({
        libelle: [this.langue.libelle, Validators.required],
        id: [this.langue.id]
      });
    } else {
      this.form = this.formBuilder.group({
        libelle: [null, Validators.required],
        id: [null]
      });
    }
  }
  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/parametrage/matrimoniale/langue/ajoutlangue/ajoutlangue.component.ts